import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type CapacityForecast } from '../../api/observability';

export function CapacityDashboardPage() {
  const [forecasts, setForecasts] = useState<CapacityForecast[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.capacity().then(setForecasts).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Capacity Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {forecasts.map((f) => {
          const pct = f.limit > 0 ? (f.projected / f.limit) * 100 : 0;
          return (
            <div key={f.id} className="rounded-xl border p-4 dark:border-slate-700">
              <p className="font-medium capitalize">{f.category}</p>
              <p className="mt-2 text-sm text-slate-500">
                Current: {f.current} {f.unit} · Projected: {f.projected} {f.unit}
              </p>
              <div className="mt-2 h-2 overflow-hidden rounded bg-slate-200 dark:bg-slate-700">
                <div className={`h-full ${pct > 85 ? 'bg-red-500' : pct > 70 ? 'bg-yellow-500' : 'bg-green-500'}`} style={{ width: `${Math.min(pct, 100)}%` }} />
              </div>
              <p className="mt-1 text-xs text-slate-400">{f.horizon_days}d horizon · limit {f.limit} {f.unit}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
